<div class="offcanvas-lg offcanvas-start" tabindex="-1" id="stSidebar" aria-labelledby="stSidebarOffcanvasLabel">
  <nav id="sidebar" class="navbar fixed-top">
    <div class="sidebar-header" *ngIf="this.user != null">
      <button type="button" class="sidebar-collapse" data-bs-dismiss="offcanvas" aria-label="Close" data-bs-target="#stSidebar">
        <span> </span>
        <span> </span>
        <span> </span>
      </button>
      <div *ngIf="this.user.Name" [@loadedFadeAnimation]="this.user.Name ? 'visible' : 'void'" class="sidebar-header_hello">
        <div><img src="/assets/images/icons/ico_usuario.svg" width="15" /></div>
        <div>
          Olá <br>{{this.user.Name}} {{this.user.Surname}}
        </div>
      </div>
    </div>
    <div *ngIf="items" [@loadedFadeAnimation]="items.length ? 'visible' : 'void'" class="offcanvas-body">
      <ul class="navbar-nav" app-menu id="MainMenu" [items]="items">
      </ul>
    </div>
  </nav>
</div>